import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import type { LabelMappingFlatten } from '~/modules/label-perf/api/label-mapping';

import { labelMappingCtx } from '../context/context';

function ContextButton(props: { label: LabelMappingFlatten }) {
  const { label } = props;
  const { setSelectedLabel } = useContext(labelMappingCtx);
  const { t } = useTranslation('label-perf');

  return (
    <div className="flex h-full items-center">
      <span
        className="cursor-pointer"
        onClick={() => {
          setSelectedLabel?.(label);
        }}
      >
        <Icon variant="solid" size="xs" type="pencil" />
        <span className="ml-xs">{t('actions.edit')}</span>
      </span>
    </div>
  );
}

ContextButton.displayName = 'ContextButton';

export { ContextButton };
